import { MediaElement, MediaImage } from 'editor/src/store/design/types';

function isImagePlaceholder(media: MediaElement): media is MediaImage {
  return media.type === 'image' && !media.imageId;
}

export default isImagePlaceholder;
